import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateTariffModel,
  DeleteTariffModel,
  ImportTariffModel,
  SearchTariffModel,
} from '../../../models/tariff.model'

@Injectable({
  providedIn: 'root',
})
export class ImportTariffService {
  private baseUrl = environment.baseUrl
  private resource: string = 'ImportTarifario'

  constructor(private httpClient: HttpClient) {}

  public importTariff(
    model: any,
    // model: ImportTariffModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/import/tarifario`,
      model,
    )
  }

  public listPagedImportTariff(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/import/tarifario?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listImportTariff(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall/import/tarifario`,
    )
  }

  public downloadLog(importTariffId: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/download/import/tarifario/log/${importTariffId}`,
    )
  }

  public downloadExcel(
    importTariffId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/download/import/tarifario/excel/${importTariffId}`,
    )
  }
}
